import { render, staticRenderFns } from "./ChartBar.vue?vue&type=template&id=ded31c62&scoped=true"
import script from "./ChartBar.vue?vue&type=script&lang=ts"
export * from "./ChartBar.vue?vue&type=script&lang=ts"
import style0 from "./ChartBar.vue?vue&type=style&index=0&id=ded31c62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded31c62",
  null
  
)

export default component.exports